import type { CSSProperties } from 'react'

import type { TextDirection } from 'lib/dom/logicalScroll'

export function getFloatingPositionStyle(
  position: CSSProperties['position'],
  x: number | null | undefined,
  y: number | null | undefined,
  textDirection: TextDirection,
): CSSProperties {
  const inlineStart = x ?? 0
  const baseStyle: CSSProperties = {
    position,
    insetBlockStart: y ?? 0,
  }

  if (textDirection === 'rtl') {
    return {
      ...baseStyle,
      insetInlineStart: `calc(100% - ${inlineStart}px)`,
      transform: 'translateX(100%)',
    }
  }

  return {
    ...baseStyle,
    insetInlineStart: inlineStart,
  }
}
